export const DEFAULT_VOLUME = 90;
export const DEFAULT_DURATION = 128;
export const DEFAULT_CHANNEL = 0;
